export default __webpack_public_path__ + "static/media/inactive-map-marker.93f5d3fa.svg";